export interface ICSVRow {
  localdatetime: string;
  utcdatetime: string;
  pitchno: number;
  date: string;
  time: string;
  paofinning: number;
  pitchofpa: number;
  pitcher: string;
  pitcherid: string;
  pitcherthrows: string;
  pitcherteam: string;
  batter: string;
  batterid: string;
  batterside: string;
  batterteam: string;
  pitcherset: string;
  inning: number;
  topbottom: string;
  outs: number;
  balls: number;
  strikes: number;
  taggedpitchtype: string;
  autopitchtype: string;
  pitchcall: string;
  korbb: string;
  taggedhittype: string;
  playresult: string;
  outsonplay: number;
  runsscored: number;
  notes: number | string;
  relspeed: number;
  vertrelangle: number;
  horzrelangle: number;
  spinrate: number;
  spinaxis: number;
  tilt: string;
  relheight: number;
  relside: number;
  extension: number;
  vertbreak: number;
  inducedvertbreak: number;
  horzbreak: number;
  platelocheight: number;
  platelocside: number;
  zonespeed: number;
  vertapprangle: number;
  horzapprangle: number;
  zonetime: string;
  exitspeed: number;
  angle: number;
  direction: number;
  hitspinrate: number;
  positionat110x: number;
  positionat110y: number;
  positionat110z: number;
  distance: number;
  lasttrackeddistance: number;
  bearing: number;
  hangtime: number;
  pfxx: number;
  pfxz: number;
  x0: number;
  y0: number;
  z0: number;
  vx0: number;
  vy0: number;
  vz0: number;
  ax0: number;
  ay0: number;
  az0: number;
  hometeam: string;
  awayteam: string;
  stadium: string;
  level: string;
  league: string;
  gameid: string;
  gameuid: string;
  pitchuid: string;
  hometeamforeignid: number;
  awayteamforeignid: number;
  gameforeignid: any; // no type on confluence page
  catcher: string;
  catcherid: string;
  catcherthrows: string;
  catcherteam: string;
  playid: string;
}

export const propNamesToForceParseAsString = ['pitcherid', 'batterid', 'catcherid', 'gameforeignid', 'localdatetime', 'utcdatetime'];
